var _defs, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1108({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.85,8.75l.66.17a2.22,2.22,0,0,1-.75,1.24,2,2,0,0,1-1.32.43,2.39,2.39,0,0,1-1.32-.33,2,2,0,0,1-.77-.95A3.39,3.39,0,0,1,3.08,8a2.93,2.93,0,0,1,.3-1.36,2.09,2.09,0,0,1,.85-.89,2.51,2.51,0,0,1,1.22-.3,2.07,2.07,0,0,1,1.26.38,2.07,2.07,0,0,1,.72,1.08L6.77,7a1.48,1.48,0,0,0-.5-.79A1.33,1.33,0,0,0,5.43,6a1.65,1.65,0,0,0-1,.27A1.54,1.54,0,0,0,3.92,7a3.12,3.12,0,0,0-.16,1A3.16,3.16,0,0,0,4,9.08a1.47,1.47,0,0,0,.58.71,1.6,1.6,0,0,0,.85.23,1.38,1.38,0,0,0,.94-.32A1.61,1.61,0,0,0,6.85,8.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.13,8.07a2.71,2.71,0,0,1,.67-2,2.26,2.26,0,0,1,1.73-.7,2.41,2.41,0,0,1,1.25.33,2.22,2.22,0,0,1,.85.92A3.11,3.11,0,0,1,12.92,8a2.87,2.87,0,0,1-.31,1.36,2,2,0,0,1-.87.91,2.46,2.46,0,0,1-1.22.31,2.33,2.33,0,0,1-1.26-.34,2.24,2.24,0,0,1-.85-.93A2.85,2.85,0,0,1,8.13,8.07Zm.68,0A2,2,0,0,0,9.3,9.5a1.7,1.7,0,0,0,2.45,0A2.15,2.15,0,0,0,12.24,8,2.51,2.51,0,0,0,12,6.94a1.57,1.57,0,0,0-.61-.71A1.59,1.59,0,0,0,10.53,6a1.7,1.7,0,0,0-1.21.48A2.15,2.15,0,0,0,8.81,8.08Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 1,
    y: 2.5,
    width: 14,
    height: 11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1108);
export default __webpack_public_path__ + "static/media/Symbolpack_1_108.7a9ddb39977d56e35e63d573a26edc76.svg";
export { ForwardRef as ReactComponent };